import * as React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import i18n from "i18n";
import { ScenarioModel } from "models/scenario";
import { settings } from "settings";

export interface ChannelsProps {
  onChange: (channel: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  model: ScenarioModel;
  locked: boolean;
}

export const Channels = (props: ChannelsProps) => (
  <Row>
    <Col xs={3}>
      <FormGroup check={true}>
        <Label check={true}>
          <Input
            type="checkbox"
            key="all"
            value="*"
            checked={props.model.channels === "*"}
            onChange={e => props.onChange("*", e)}
            disabled={props.locked}
          />
          {i18n.Global.AllOption}
        </Label>
      </FormGroup>
    </Col>
    {settings.channels.filter((c: string) => c !== "").map((c: string) => (
      <Col xs={3} key={c}>
        <FormGroup check={true} className="col-2">
          <Label check={true}>
            <Input
              type="checkbox"
              value={c}
              checked={
                !!props.model.channels &&
                props.model.channels.split(",").indexOf(c) > -1
              }
              onChange={e => props.onChange(c, e)}
              disabled={
                props.model.channels === "*" ||
                (/voice/i.test(props.model.channels) && /alexa|ivr/i.test(c)) ||
                (/voice/i.test(c) && /alexa|ivr/i.test(props.model.channels)) ||
                (!!props.model.keywords && /alexa|ivr/i.test(c)) ||
                props.locked
              }
            />
            {c}
          </Label>
        </FormGroup>
      </Col>
    ))}
  </Row>
);



// WEBPACK FOOTER //
// ./src/utils/channels.tsx